import {
  IOutcomeMovement,
  IOutcomeMovementDocument,
  IOutcomeOrder,
  MovementOutcome,
  MovementOutcomeKind,
} from '@interfaces/movement-outcome';
import { DepositStatus, MovementStatus, OrderOperation, OrderStatus, WithdrawalStatus } from '@interfaces/movements';

const BROKER_REJECTED_ORDER_STATUSES: string[] = [OrderStatus.Failed, OrderStatus.Rejected, OrderStatus.Canceled];

export function isBrokerRejectedOrder(order?: IOutcomeOrder): boolean {
  if (!order) {
    return false;
  }
  const status = order.status || '';
  const isRejectedStatus = BROKER_REJECTED_ORDER_STATUSES.indexOf(status) !== -1;
  // TODO(RTC-4973): drop once the 381 legacy orders are backfilled to status 'failed'.
  return isRejectedStatus || order.failedOrder === true;
}

export function hasExecutedSellAmountUSD(movement?: IOutcomeMovementDocument): boolean {
  const shareVariations = movement ? movement.executedShareVariations : undefined;
  const isShareVariationList = Array.isArray(shareVariations);
  const firstShareVariation = isShareVariationList ? shareVariations[0] : undefined;
  return !!firstShareVariation && typeof firstShareVariation.amountUSD === 'number';
}

export function isBrokerRejectedDeposit(deposit?: IOutcomeMovementDocument): boolean {
  if (!deposit) {
    return false;
  }
  return deposit.status === DepositStatus.Failed || deposit.failedOrder === true;
}

export function isBrokerRejectedWithdrawal(withdrawal?: IOutcomeMovementDocument): boolean {
  if (!withdrawal) {
    return false;
  }
  const isFailedSell = withdrawal.status === WithdrawalStatus.Failed && withdrawal.isSell === true;
  if (!isFailedSell) {
    return false;
  }
  const sellSettled = hasExecutedSellAmountUSD(withdrawal);
  return !sellSettled;
}

export function resolveMovementOutcome(movement?: IOutcomeMovement, order?: IOutcomeOrder): MovementOutcome {
  if (!movement) {
    return { kind: MovementOutcomeKind.Pending };
  }

  if (order && isBrokerRejectedOrder(order)) {
    if (movement.resource === OrderOperation.Deposit && movement.status === DepositStatus.Complete) {
      return { kind: MovementOutcomeKind.CompletedAsCash };
    }
    return {
      kind: MovementOutcomeKind.RejectedByBroker,
      code: order.rejectionCode,
      message: order.rejectionMessage,
    };
  }

  if (movement.status === MovementStatus.Failed) {
    return { kind: MovementOutcomeKind.TransferFailed };
  }

  if (movement.status === MovementStatus.Complete) {
    return { kind: MovementOutcomeKind.Fulfilled };
  }

  return { kind: MovementOutcomeKind.Pending };
}
